import { render, staticRenderFns } from "./DrawerUserTasks.vue?vue&type=template&id=33d27096&"
import script from "./DrawerUserTasks.vue?vue&type=script&lang=ts&"
export * from "./DrawerUserTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports